import { createContext, useMemo } from 'react';
import type { PropsWithChildren } from 'react';

import {
  HttpService,
  createHttpClient,
} from '@storebrand-digital/bank-foundation-http-service';

import { httpClientConfig } from '@api/config/httpClient';
import CommonService from '@api/service/CommonService';
import CreditCardService from '@api/service/CreditCardService';
import EditMortgageService from '@api/service/EditMortgageService';
import OnlineBankForChildrenService from '@api/service/OnlineBankForChildrenService';
import OnlineBankService from '@api/service/OnlineBankService';

interface ApiContextValue {
  commonService: CommonService;
  creditCardService: CreditCardService;
  editMortgageService: EditMortgageService;
  onlineBankForChildrenService: OnlineBankForChildrenService;
  onlineBankService: OnlineBankService;
}

export const ApiContext = createContext<ApiContextValue | null>(null);

export function ApiProvider({ children }: PropsWithChildren) {
  const value = useMemo((): ApiContextValue => {
    const httpClient = createHttpClient(httpClientConfig);
    const httpService = new HttpService(httpClient);

    return {
      commonService: new CommonService(httpService),
      creditCardService: new CreditCardService(httpService),
      editMortgageService: new EditMortgageService(httpService),
      onlineBankForChildrenService: new OnlineBankForChildrenService(
        httpService
      ),
      onlineBankService: new OnlineBankService(httpService),
    };
  }, []);

  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
}
